export const API_ROUTES = {
  // Auth
  LOGIN: '/Auth/login',
  REGISTER: '/Auth/register',
  VERIFY_EMAIL: '/Auth/verify-email',
  RESEND_VERIFICATION: '/Auth/resend-verification',
  SOCIAL_LOGIN: '/Auth/socialmedia-login',
  FORGOT_PASSWORD: '/Auth/forgot-password',
  RESET_PASSWORD: '/Auth/reset-password',
  SET_PASSWORD: '/Auth/set-password',
  ACCEPT_INVITATION: '/Auth/accept-invitation',
  VERIFY_TOKEN: '/Auth/verify-token',

  // User onboarding
  CREATE_FAMILY_SPACE_AND_MEMBER: '/User/CreateFamilySpaceAndmember',
  VALIDATE_FAMILY_MEMBER_EMAIL: '/User/validate-familymember',
  SKIP_FAMILY_SPACE: '/User/skip-add-family-space',

  // Profile
  GET_PROFILE: '/Client/GetProfileById',
  UPDATE_PROFILE: '/Client/UpdateProfile',
  UPDATE_PASSWORD: '/Client/ChangePassword',
  UPDATE_PROFILE_PICTURE: '/Client/UpdateProfileImage',

  // Dashboard
  GET_DASHBOARD_STATS: '/Client/GetDashboardStats',
  GET_RECENT_ACTIVITY: '/Client/GetRecentActivity',

  // Stories — listing
  GET_STORY_LISTING:      '/Story/GetStoryListing',
  GET_ACTIVE_CATEGORIES:  '/Story/GetActiveCategories',
  GET_ACTIVE_FAMILY_LIST: '/Story/GetActiveFamilyList',
  GET_FAMILY_MEMBER_LIST: '/Story/GetFamilyMemberList',

  // Stories — detail & reactions
  /** GET /Story/GetStoryDetail/{storyId} */
  GET_STORY_DETAIL: '/Story/GetStoryDetail',
  /** POST /Story/AddReaction — body: AddReactionRequest */
  ADD_REACTION:     '/Story/AddReaction',
  /** DELETE /Story/RemoveReaction/{storyId} */
  REMOVE_REACTION:  '/Story/RemoveReaction',

  // Stories — creation flow
  /** GET /Story/GetPromptsForCategory/{categoryId} — Step 3: AI + custom questions */
  GET_PROMPTS_FOR_CATEGORY: '/Story/GetPrmoptForCategory',
  /** POST /Story/AddCustomQuestion — { categoryId, questionText } */
  ADD_CUSTOM_QUESTION: '/Story/AddCustomQuestion',
  /** PUT /Story/UpdateCustomQuestion — { customQuestionId, questionText } */
  UPDATE_CUSTOM_QUESTION: '/Story/UpdateCustomQuestion',
  /** DELETE /Story/DeleteCustomQuestion/{customQuestionId} */
  DELETE_CUSTOM_QUESTION: '/Story/DeleteCustomQuestion',
  /** GET /Story/GetEmotionalTones — Step 4 organize: emotional tone dropdown */
  GET_EMOTIONAL_TONES: '/Story/GetEmotionalTones',
  /** POST /Story/CreateAndPublishStory — final publish */
  CREATE_AND_PUBLISH_STORY: '/Story/CreateAndPublishStory',
} as const;
